import productsApi from '@/services/calls/products'
import {
  AttributeConfigsResponse,
  BaseProduct,
  CategoriesResponse,
  ProductsOverviewResponse,
  ProductsResponse,
} from '@/types/products'
import { defineStore } from 'pinia'

interface States {
  products: Ref<ProductsResponse | null>
  categories: Ref<CategoriesResponse | null>
  selectedBaseBottle: Ref<BaseProduct | null>
  productsOverview: Ref<ProductsOverviewResponse | null>
  attributeConfigs: Ref<AttributeConfigsResponse | null>
  productAnalyticsRetailerCount: Ref<number | null>
}

export const useProductStore = defineStore('product', () => {
  const states: States = {
    products: ref(null),
    categories: ref(null),
    selectedBaseBottle: ref(null),
    productsOverview: ref(null),
    attributeConfigs: ref(null),
    productAnalyticsRetailerCount: ref(null),
  }

  const getCategories = async () => {
    const response = await productsApi.getCategories()
    states.categories.value = response
  }

  const resetStore = () => {
    states.products.value = null
    states.categories.value = null
    states.selectedBaseBottle.value = null
  }

  return {
    ...states,
    getCategories,
    resetStore,
  }
})
